module.exports = __webpack_public_path__ + "img/load_xj.77168825.svg";